import { UserFormPage } from '@/app/pages/user-form/user-form-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/user-form/')({
  validateSearch: z.object({
    travelId: z.string().uuid(),
  }),
  component: UserFormPage,
});
